import { claimPendindActions, PMFBY } from "../../consts.js";
import CustomProductSelect from "../../utilsComponent/CustomProductSelect.jsx";
import CustomMultiSelect from "../../reusableComponents/CustomMultiSelect.jsx";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { titleCase } from "../../utilFunctions.js";
import { useEffect, useState } from "react";
import { fetchFlaggedClaimsOptions } from "../claimLitigation/litigationApi.js";
import { toast } from "react-toastify";
import { fetchBasicSearch } from "./apiHelper.js";

const MyWorkItemsFilter = (props) => {
  const {
    productNames,
    selectedProducts,
    setSelectedProducts,
    setClaimslist,
    claimSubStatus,
    policyStatusOptions,
    flaggedClaimsOptions,
    setFlaggedClaimsOptions,
    setLoading,
    selectedPage,
    itemsPerPage,
    setItemsPerPage,
    setPageCount,
    setSelectedPage,
    setTotalRecords,
    setSearchResultMode,
    scrollRef,
    triggerAPi,
    userID,
  } = props;
  const defaultSearch = {
    productName: "",
    pendingActions: "",
    policyID: "",
    perilFromDate: "",
    perilToDate: "",
    policyStatus: "",
    selectedFlags: [],
    claimID: "",
    fromDate: "",
    toDate: "",
    claimSubStatus: "",
  };
  const [searchFields, setSearchFields] = useState(defaultSearch);
  const handleProductChange = (selected) => {
    const selectedArray = Array.isArray(selected)
      ? selected
      : selected
      ? [selected]
      : [];
    setSelectedProducts(selectedArray);
    const lastSelected = selectedArray[selectedArray.length - 1];
    setSearchFields({
      ...searchFields,
      productName: lastSelected ?? "",
      claimIngestionType:
        lastSelected?.label !== PMFBY ? "" : searchFields?.claimIngestionType,
      calamityType:
        lastSelected?.label !== PMFBY ? "" : searchFields?.calamityType,
    });
  };
  const handleIntimationDateRange = (date, key) => {
    if (date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const dat1 = date.getDate().toString().padStart(2, "0");
      setSearchFields({ ...searchFields, [key]: `${year}-${month}-${dat1}` });
    }
  };
  const handleFlaggedClaimsChange = (selected) => {
    const data = Array.isArray(selected) ? selected : [];
    const flagIds = data.map((o) => o.flagId);
    setSearchFields({
      ...searchFields,
      selectedFlags: flagIds ?? [],
    });
  };
  const handlePerilDateChange = (date, key) => {
    if (date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const dat1 = date.getDate().toString().padStart(2, "0");
      setSearchFields({ ...searchFields, [key]: `${year}-${month}-${dat1}` });
    }
  };
  const handleScroll = () => {
    if (scrollRef.current) {
      const element = scrollRef.current;
      const scrollPosition = element.scrollHeight * 0.5;
      element.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
      scrollRef.current?.scrollIntoView({
        top: scrollPosition,
        behavior: "smooth",
      });
    }
  };
  const handleReset = () => {
    setSearchFields(defaultSearch);
    setSelectedPage(1);
    setItemsPerPage(10);
    setSelectedProducts([]);
    basicSearch(null,"resetClick");
  }
  useEffect(() => {
    async function loadFlagOptions() {
      try {
        const data = await fetchFlaggedClaimsOptions(setLoading);
        const options = (Array.isArray(data) ? data : [])
          .filter((item) => item.isActive)
          .map((item) => ({
            label: item.flagName,
            value: item.flagId,
            flagId: item.flagId,
          }));
        setFlaggedClaimsOptions(options);
      } catch (err) {
        console.error("Error fetching flagged claims:", err);
      }
    }
    loadFlagOptions();
  }, []);

  useEffect(() => {
    basicSearch();
  }, [triggerAPi]);

  const basicSearch = (buttonClick, resetClick) => {
    if (
      buttonClick &&
      searchFields.productName === "" &&
      searchFields.pendingActions === "" &&
      searchFields.policyID === "" &&
      searchFields.perilFromDate === "" &&
      searchFields.perilToDate === "" &&
      searchFields.policyStatus === "" &&
      searchFields.selectedFlags?.length === 0 &&
      searchFields.claimID === "" &&
      searchFields.fromDate === "" &&
      searchFields.toDate === "" &&
      searchFields.claimSubStatus === ""
    ) {
      toast.error("Please Input a search Parameter");
      return;
    }
    setLoading(true);
    const payload = resetClick
      ? {
        isMyWorkItems: true,
        assignedTo: userID,
        productName: 0,
        multipleProductNames: null,
        pendingActions: "",
        policyID: "",
        perilFromDate: "",
        perilToDate: "",
        policyStatus: "",
        selectedFlags: [],
        claimID: "",
        fromDate: "",
        toDate: "",
        claimSubStatus: "",
        pageNo: 1,
        count: 10
        }
      : {
          isMyWorkItems: true,
          assignedTo: userID,
          productName: 0,
          multipleProductNames: selectedProducts?.length
            ? selectedProducts?.map((product) => product?.value)
            : null,
          pendingActions: searchFields?.pendingActions,
          policyID: searchFields?.policyID,
          perilFromDate: searchFields?.perilFromDate
            ? searchFields?.perilFromDate + "T00:00:00.000"
            : "",
          perilToDate: searchFields?.perilToDate
            ? searchFields?.perilToDate + "T23:59:59.999"
            : "",
          policyStatus: searchFields?.policyStatus
            ? searchFields?.policyStatus
            : "",
          selectedFlags: Array.isArray(searchFields?.selectedFlags)
            ? searchFields?.selectedFlags
            : [],
          claimID: searchFields?.claimID,
          fromDate: searchFields?.fromDate
            ? searchFields?.fromDate + "T00:00:00.000"
            : "",
          toDate: searchFields?.toDate
            ? searchFields?.toDate + "T23:59:59.999"
            : "",
          claimSubStatus: searchFields?.claimSubStatus,
          pageNo: selectedPage,
          count: itemsPerPage,
        };
    fetchBasicSearch(payload)
      .then((data) => {
        const claimIntimationLists = { ...data.data };
        setClaimslist(data?.data?.claimDetailDTOs);
        setPageCount(claimIntimationLists?.totalPages);
        setSelectedPage(claimIntimationLists?.currentPage);
        setItemsPerPage(claimIntimationLists?.pageSize);
        setTotalRecords(claimIntimationLists.totalRecords);
        setSearchResultMode(true);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="border rounded p-2 px-1">
      <div className="d-md-flex align-items-center justify-content-around mt-3">
        <div className="form-group w-23">
          <label for="exampleInputPassword1">Product Name</label>
          <CustomProductSelect
            productNames={productNames}
            handleProductChange={handleProductChange}
            selectedProducts={selectedProducts}
          />
        </div>
        <div className="form-group w-23">
          <label htmlFor="exampleInputPassword1">Pending Actions</label>
          <Select
            id="exampleInputPassword1"
            options={claimPendindActions}
            classNamePrefix="bg-gray"
            placeholder="Select Pending Actions"
            value={
              searchFields.pendingActions
                ? {
                    label: searchFields.pendingActions,
                    value: searchFields.pendingActions,
                  }
                : null
            }
            onChange={(data) => {
              setSearchFields({
                ...searchFields,
                pendingActions: data?.value ?? "",
              });
            }}
            isClearable={true}
          />
        </div>
        <div className="form-group w-23">
          <label for="exampleInputPassword3">Policy ID</label>
          <input
            type="text"
            className="form-control bg-gray"
            id="exampleInputPassword3"
            placeholder="Enter Policy ID"
            onChange={(e) => {
              const numericValue = e.target.value.replace(
                /[^A-Za-z0-9\/]/g,
                ""
              ); // Replace non-alphanumeric characters
              e.target.value = numericValue;
              setSearchFields({
                ...searchFields,
                policyID: e.target.value,
              });
            }}
            value={searchFields.policyID}
          />
        </div>
        <div className="form-group w-23">
          <label for="exampleInputPassword3">Peril Occurrence Date</label>
          <div className="d-md-flex intimation-date">
            <div className="from-date">
              <DatePicker
                className="form-control bg-gray"
                selected={
                  searchFields?.perilFromDate && searchFields?.perilFromDate
                }
                dateFormat="dd-MM-yy"
                placeholderText="From date"
                maxDate={
                  searchFields?.perilToDate
                    ? new Date(searchFields?.perilToDate)
                    : new Date()
                }
                onChange={(date) =>
                  handleIntimationDateRange(date, "perilFromDate")
                }
                onKeyDown={(e) => e.preventDefault()}
                showYearDropdown
                showMonthDropdown
                scrollableYearDropdown
                yearDropdownItemNumber={1000}
              />
            </div>
            <div className="to-date">
              <DatePicker
                className="form-control bg-gray"
                selected={
                  searchFields?.perilToDate && searchFields?.perilToDate
                }
                dateFormat="dd-MM-yy"
                placeholderText="To date"
                minDate={new Date(searchFields?.perilFromDate)}
                maxDate={new Date()}
                onChange={(date) =>
                  handleIntimationDateRange(date, "perilToDate")
                }
                onKeyDown={(e) => e.preventDefault()}
                showYearDropdown
                showMonthDropdown
                scrollableYearDropdown
                yearDropdownItemNumber={1000}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="d-md-flex align-items-center justify-content-around mt-3">
        <div className="form-group w-23">
          <label htmlFor="exampleInputPassword2">Policy Status</label>
          <Select
            id="exampleInputPassword2"
            options={policyStatusOptions}
            classNamePrefix="bg-gray"
            placeholder="Select Policy Status"
            value={
              searchFields.policyStatus
                ? {
                    label: titleCase(searchFields.policyStatus),
                    value: searchFields.policyStatus,
                  }
                : null
            }
            onChange={(data) => {
              setSearchFields({
                ...searchFields,
                policyStatus: data?.value ?? "",
              });
            }}
            isClearable={true}
          />
        </div>
        <div className="form-group w-23">
          <label>Flagged Claims</label>
          <CustomMultiSelect
            label="Flagged Claims"
            placeholder="Flagged Claims"
            options={flaggedClaimsOptions}
            value={flaggedClaimsOptions.filter((opt) =>
              searchFields?.selectedFlags?.includes(opt.flagId)
            )}
            onChange={handleFlaggedClaimsChange}
            isMulti
            isDisabled={false}
            isClearable={true}
            showCountOnly={true}
          />
        </div>
        <div className="form-group w-23">
          <label for="exampleInputPassword3">Claim ID</label>
          <input
            type="text"
            className="form-control bg-gray"
            id="exampleInputPassword3"
            placeholder="Enter Claim ID"
            onChange={(e) => {
              const numericValue = e.target.value.replace(/[^A-Za-z0-9]/g, ""); // Replace non-alphanumeric characters
              e.target.value = numericValue;
              setSearchFields({
                ...searchFields,
                claimID: e.target.value,
              });
            }}
            value={searchFields.claimID}
          />
        </div>
        <div className="form-group w-23 ">
          <label for="exampleInputPassword3">Claim Intimation Date</label>
          <div className="d-md-flex intimation-date">
            <div className="from-date">
              <DatePicker
                className="form-control bg-gray"
                selected={searchFields?.fromDate && searchFields?.fromDate}
                dateFormat="dd-MM-yy"
                placeholderText="From date"
                maxDate={
                  searchFields?.toDate
                    ? new Date(searchFields?.toDate)
                    : new Date()
                }
                onChange={(date) => handlePerilDateChange(date, "fromDate")}
                onKeyDown={(e) => e.preventDefault()}
                showYearDropdown
                showMonthDropdown
                scrollableYearDropdown
                yearDropdownItemNumber={1000}
              />
              {/* <label for="exampleInputPassword3">To Date</label> */}
            </div>
            <div className="to-date">
              <DatePicker
                className="form-control bg-gray"
                selected={searchFields?.toDate && searchFields?.toDate}
                dateFormat="dd-MM-yy"
                placeholderText="To date"
                minDate={new Date(searchFields?.fromDate)}
                maxDate={new Date()}
                onChange={(date) => handlePerilDateChange(date, "toDate")}
                onKeyDown={(e) => e.preventDefault()}
                showYearDropdown
                showMonthDropdown
                scrollableYearDropdown
                yearDropdownItemNumber={1000}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="d-md-flex align-items-center justify-content-around mt-3">
        <div className="form-group w-23">
          <label for="exampleInputPassword1">Claim Sub Status</label>
          <Select
            id="exampleInputPassword1"
            options={claimSubStatus}
            onInputChange={(inputValue) => {
              // Replace non-alphanumeric characters
              const cleanedValue = inputValue.replace(/[^A-Za-z]/g, "");
              return cleanedValue; // Return cleaned value for the Select component
            }}
            classNamePrefix="bg-gray"
            placeholder="Select Claim Sub Status"
            //isDisabled={!searchFields.mandal}
            value={
              searchFields.claimSubStatus
                ? {
                    label: searchFields.claimSubStatus,
                    value: searchFields.claimSubStatus,
                  }
                : null
            }
            onChange={(data) => {
              setSearchFields({
                ...searchFields,
                claimSubStatus: data?.value ?? "",
              });
            }}
            isClearable={true}
          />
        </div>
        <div className="form-group w-23"></div>
        <div className="form-group w-23"></div>
        <div className="form-group w-23"></div>
      </div>
      <div className="d-flex mx-3">
        <div className="form-group">
          <button
            className="btn btn-success m-4 mb-0 px-4"
            onClick={() => {
              basicSearch("buttonClick");
              handleScroll();
            }}
          >
            Search
          </button>
        </div>
        <div className="form-group">
          <div
            className="btn btn-outline-success mt-4 mb-0 px-4"
            onClick={() => {
              handleReset();
            }}
          >
            Reset
          </div>
        </div>
      </div>
    </div>
  );
};
export default MyWorkItemsFilter;
